/* Royal Hair – global card media rule (loaded once in layout/theme.liquid).
   2026-10-22: card videos (product media 2 = video) behave like a moving product image on
   every device: muted, looping, inline, no controls. They start when the card is visible,
   pause when it scrolls off-screen, and only cover image 1 once a real frame is painted
   (image 1 is the poster while loading, so there is no layout shift).
   Reduced-motion users keep the previous rule: desktop hover only, nothing on touch. */
(function () {
  'use strict';
  if (window.__rhCardMedia) return;
  window.__rhCardMedia = true;
  var root = document.documentElement;
  var hoverMq = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)');
  var canHover = !!(hoverMq && hoverMq.matches);
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var auto = !reduce && 'IntersectionObserver' in window;
  if (canHover) root.classList.add('rh-can-hover');
  if (auto) root.classList.add('rh-av');
  var CARD = '.rh-card, .rrr__item, .rrb__card, .card-wrapper, [data-rh-m2-card]';
  var MEDIA = '.rh-card__media, .rrr__media, .rrb__media, .card__media .media, .rh-m2';
  function holder(v) { return v.closest(MEDIA) || v.parentElement; }
  function prep(v) {
    if (v.dataset.rhBound) return;
    v.dataset.rhBound = '1';
    v.muted = true; v.defaultMuted = true; v.setAttribute('muted', '');
    v.playsInline = true; v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
    v.controls = false; v.removeAttribute('controls');
    v.setAttribute('disablepictureinpicture', ''); v.setAttribute('disableremoteplayback', '');
    v.addEventListener('playing', function () {
      if (!v.dataset.rhOn) return;
      var swap = function () {
        if (!v.dataset.rhOn || v.paused) return;
        v.classList.add('is-playing');
        var m = holder(v); if (m) m.classList.add('rh-hv-on');
      };
      if (v.requestVideoFrameCallback) v.requestVideoFrameCallback(swap); else swap();
    });
  }
  function play(v) {
    prep(v);
    v.dataset.rhOn = '1';
    if (v.preload === 'none') v.preload = 'auto';
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  }
  function pause(v, rewind) {
    delete v.dataset.rhOn;
    v.pause();
    if (rewind) { try { v.currentTime = 0; } catch (e) {} }
    v.classList.remove('is-playing');
    var m = holder(v); if (m) m.classList.remove('rh-hv-on');
  }

  if (auto) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting && e.intersectionRatio >= 0.35) play(v); else if (v.dataset.rhOn) pause(v, false);
      });
    }, { threshold: [0, 0.35, 0.6] });
    var watch = function (scope) {
      (scope || document).querySelectorAll('video[data-rh-hover-video]').forEach(function (v) {
        if (v.__rhAv) return; v.__rhAv = true; prep(v); io.observe(v);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { watch(document); });
    else watch(document);
    /* Cards added later (section reload in the editor, recommendations, quick views). */
    document.addEventListener('shopify:section:load', function (e) { watch(e.target); });
    window.addEventListener('pageshow', function () { watch(document); });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) document.querySelectorAll('video[data-rh-hover-video]').forEach(function (v) { if (v.dataset.rhOn) { v.pause(); } });
      else document.querySelectorAll('video[data-rh-hover-video]').forEach(function (v) { if (v.dataset.rhOn) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } });
    });
    return;
  }

  /* Reduced motion: previous rule – desktop hover only. */
  if (!canHover) return;
  document.addEventListener('mouseover', function (e) {
    var card = e.target.closest && e.target.closest(CARD);
    if (!card) return;
    var v = card.querySelector('[data-rh-hover-video]');
    if (!v || v.dataset.rhOn) return;
    play(v);
  });
  document.addEventListener('mouseout', function (e) {
    var card = e.target.closest && e.target.closest(CARD);
    if (!card || (e.relatedTarget && card.contains(e.relatedTarget))) return;
    var v = card.querySelector('[data-rh-hover-video]');
    if (v) pause(v, true);
  });
})();
